// src/data/exercises/L4_03.js

const accountOptions = [
  '所得税預り金', '普通預金', '給料', '租税公課', '従業員立替金'];

export const L4_03 = {
  title: '簿記　3級（第212-3回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

      parts: [
    { "type": "ruby", "text": "従業員", "ruby": "じゅうぎょういん" },
    { "type": "text", "value": "への" },
    { "type": "ruby", "text": "給料", "ruby": "きゅうりょう" },
    { "type": "text", "value": "￥267,000の" },
    { "type": "ruby", "text": "支払", "ruby": "しはらい" },
    { "type": "text", "value": "いに" },
    { "type": "ruby", "text": "際", "ruby": "さい" },
    { "type": "text", "value": "して、" },
    { "type": "ruby", "text": "所得税", "ruby": "しょとくぜい" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "源泉徴収額", "ruby": "げんせんちょうしゅうがく" },
    { "type": "text", "value": "￥28,000を" },
    { "type": "ruby", "text": "差", "ruby": "さ" },
    { "type": "text", "value": "し" },
    { "type": "ruby", "text": "引", "ruby": "ひ" },
    { "type": "text", "value": "き、" },
    { "type": "ruby", "text": "普通預金", "ruby": "ふつうよきん" },
    { "type": "ruby", "text": "口座", "ruby": "こうざ" },
    { "type": "text", "value": "から" },
    { "type": "ruby", "text": "口座振込", "ruby": "こうざふりこみ" },
    { "type": "text", "value": "で" },
    { "type": "ruby", "text": "支払", "ruby": "しはら" },
    { "type": "text", "value": "った。" }
]

      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '給料', debitAmount: 260000, creditAccount: '所得税預り金', creditAmount: 28000 },
        { debitAccount: null, debitAmount: null, creditAccount: '普通預金', creditAmount: 239000 },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {

        parts: [
          { type: 'text', value: '従業員への給料￥267,000の支払い\n' },
          { type: 'text', value: '①給料が発生します。\n' },
          { type: 'styled', value: '給料の発生は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },

          { type: 'text', value: '所得税の源泉徴収額￥28,000\n' },
          { type: 'text', value: '②所得税預り金が増加（プラス）します。\n' },
          { type: 'styled', value: '所得税預り金の増加（プラス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          
          { type: 'text', value: '普通預金から口座振替で支払った。\n' },
          { type: 'text', value: '③普通預金が減少（マイナス）します。\n' },
          { type: 'styled', value: '普通預金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`従業員への給料￥260,000の支払い
①給料が発生します。

所得税の源泉徴収額￥28,000
②所得税預り金が増加（プラス）します。
           
普通預金から口座振替で支払った。
③普通預金が減少（マイナス）します。  `,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
           parts: [
          { type: 'text', value: '従業員への給料￥267,000の支払い\n' },
          { type: 'text', value: '①給料が発生します。\n' },
          { type: 'styled', value: '給料の発生は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },

          { type: 'text', value: '所得税の源泉徴収額￥28,000\n' },
          { type: 'text', value: '②所得税預り金が増加（プラス）します。\n' },
          { type: 'styled', value: '所得税預り金の増加（プラス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          
          { type: 'text', value: '普通預金から口座振替で支払った。\n' },
          { type: 'text', value: '③普通預金が減少（マイナス）します。\n' },
          { type: 'styled', value: '普通預金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
          }
        ],
       
      },
    },
  ],
};